module.exports = __webpack_public_path__ + "static/img/icon_next2.970927b4.png";